const theme = {
  color: {
    white: '#ffffff',
    lightGrey: '#ccc',

    primary: '#f96302',
    get primaryDark() { return this.primary; },
    get primaryDarker() { return this.primary; },
    primaryDarkest: '#e25900',
    primaryLight: '#fff',
    primaryLighter: '#f4f4f4',
    primaryLightest: '#fcfcfc',

    secondary: '#43474d',
    secondaryDark: '#333333',
    get secondaryDarker() { return this.secondaryDark; },
    get secondaryDarkest() { return this.secondaryDark; },
    secondaryLight: '#666666',
    get secondaryLighter() { return this.secondaryLight; },
    get secondaryLightest() { return this.secondaryLight; },

    danger: '#c80000',
    get dangerDark() { return this.danger; },
    get dangerDarker() { return this.danger; },
    get dangerDarkest() { return this.danger; },
    get dangerLight() { return this.danger; },
    dangerLighter: '#fcdfdd',
    get dangerLightest() { return this.dangerLighter; },

    success: '#02a44a',
    get successDark() { return this.success; },
    get successDarker() { return this.success; },
    get successDarkest() { return this.success; },
    get successLight() { return this.success; },
    get successLighter() { return this.success; },
    get successLightest() { return this.success; },

    warning: '#ffe500',
    get warningDark() { return this.warning; },
    get warningDarker() { return this.warning; },
    get warningDarkest() { return this.warning; },
    get warningLight() { return this.warning; },
    warningLighter: '#ffffea',
    get warningLightest() { return this.warningLighter; },

    header: '#000',
    link: '#3e7697',
    icons: '#3e7697',

    bgItemLabel: '#000',
    fgItemLabel: '#fff',

    selected: {
      background: 'rgba(249, 99, 2, 0.125)',
    },
  },
};
export default theme;
